/*eslint-disable*/
export const messages = {
  "Cancel": "Cancelar",
  "Change theme": "Cambiar tema",
  "Clear chat": "Borrar chat",
  "Clear chat history": "Borrar historial de chat",
  "Connecting...": "Conectando...",
  "Continue": "Continuar",
  "Decrease font size": "Disminuir tamaño de fuente",
  "Disclaimer": "Aviso legal",
  "Enter your message...": "Escribe tu mensaje...",
  "Type your message...": "Escribe tu mensaje...",
  "Error": "Error",
  "Font size": "Tamaño de fuente",
  "Increase font size": "Aumentar tamaño de fuente",
  "Language": "Idioma",
  "MJ Lab": "Laboratorio MJ",
  "Reset font size": "Restablecer tamaño de fuente",
  "Respond time: {time}s": "Tiempo de respuesta: {time}s",
  "Response time:": "Tiempo de respuesta:",
  "Send": "Enviar",
  "Settings": "Configuración",
  "Support the project": "Apoyar el proyecto",
  "System": "Sistema",
  "Theme": "Tema",
  "Thinking...": "Pensando...",
  "Toggle theme": "Alternar tema",
  "Welcome to Kai by MJ": "Bienvenido a Kai por MJ",
  "You asked:": "Preguntaste:",
  
  // Headers
  "Labor Law Expert": "Experto en Derecho Laboral",
  "by MJ": "por MJ",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "Hola, soy {{name}}, un asistente de IA creado por MJ.",
  "I am expert in labor laws and regulations for Saudi Arabia.": "Soy experto en leyes y regulaciones laborales de Arabia Saudita.",
  "Ask me a question, and I will gladly answer you.": "Hazme una pregunta y con gusto te responderé.",
  "Do not share confidential data.": "No compartas datos confidenciales.",
  "I am powered using": "Funciono utilizando",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi labor laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**Aviso legal:** {{name}} es un asistente de IA experimental diseñado para responder utilizando datos de las leyes y regulaciones laborales de Arabia Saudita, evitando suposiciones o inexactitudes. No soy responsable de su comportamiento o la corrección de sus respuestas.",
  
  // Frameworks
  "Automatic detection": "Detección automática",
  "Labor Law": "Derecho Laboral",
  "Saudization": "Saudización",
  "Contracts": "Contratos",
  "Termination": "Terminación",
  "Wages & Benefits": "Salarios y Beneficios",
  "Leave Policies": "Políticas de Ausencia",
  "Workplace Safety": "Seguridad Laboral",
  
  // Models
  "Claude by Anthropic": "Claude por Anthropic",
  "DeepSeek by Groq": "DeepSeek por Groq",
  "MJ Lab Mode": "Modo Laboratorio MJ",
  
  // Character count
  "{{remainingChars}} character left": "{{remainingChars}} carácter restante",
  "{{remainingChars}} characters left": "{{remainingChars}} caracteres restantes",
  
  // Error messages
  "An error occurred": "Ha ocurrido un error",
  "Failed to change language": "No se pudo cambiar el idioma",
  "Please try again": "Por favor, inténtalo de nuevo",
  "Connection lost": "Conexión perdida",
  "Reconnecting...": "Reconectando...",
  "Nothing to clear": "Nada que borrar",
  "All messages cleared": "Todos los mensajes borrados",
  "All data cleared": "Todos los datos borrados",
  "Storage limit reached": "Límite de almacenamiento alcanzado",
  "Some older messages were removed to save space.": "Algunos mensajes antiguos se eliminaron para ahorrar espacio.",
  
  // Additional keys
  "Font Size": "Tamaño de fuente",
  "Language changed to {{locale}}": "Idioma cambiado a {{locale}}",
  "Select language": "Seleccionar idioma",
  "Support": "Soporte",
  
  // Brand names (do not translate)
  "Leen": "Leen",
  
  // Message actions
  "Message copied to clipboard": "Mensaje copiado al portapapeles",
  "Read": "Leer",
  "Summarize": "Resumir",
  
  // Ice Breakers Dialog
  "Message Suggestions": "Sugerencias de mensajes",
  "Select a question to quickly start a conversation about Saudi labor laws.": "Selecciona una pregunta para iniciar rápidamente una conversación sobre las leyes laborales de Arabia Saudita.",
  "What are the key employee rights under Saudi labor law? Can you provide a simple overview?": "¿Cuáles son los derechos fundamentales de los empleados según la ley laboral saudita? ¿Puedes proporcionar una visión general simple?",
  "What are the employer's obligations regarding work hours, overtime, and leave in Saudi Arabia?": "¿Cuáles son las obligaciones del empleador respecto a las horas de trabajo, horas extras y permisos en Arabia Saudita?",
  "How does Saudi labor law handle termination of employment and end-of-service benefits?": "¿Cómo maneja la ley laboral saudita la terminación del empleo y los beneficios por fin de servicio?",
  
  // Audio Player Dialog
  "AI Summary": "Resumen de IA",
  "Listen to the summarized response using our AI Service.": "Escucha la respuesta resumida usando nuestro Servicio de IA.",
  "Generating summary...": "Generando resumen...",
  "Preparing audio...": "Preparando audio...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "Error al procesar texto. Por favor, inténtalo de nuevo.",
  "Failed to auto-play audio. Click play to try again.": "Error al reproducir audio automáticamente. Haz clic en reproducir para intentarlo de nuevo.",
  "Failed to load audio. Please try again.": "Error al cargar audio. Por favor, inténtalo de nuevo.",
  "Audio playback was aborted.": "La reproducción de audio fue interrumpida.",
  "Network error occurred while loading audio.": "Ocurrió un error de red al cargar el audio.",
  "Audio decoding failed.": "Falló la decodificación del audio.",
  "Audio format not supported.": "Formato de audio no compatible.",
  "Failed to setup audio playback": "Error al configurar la reproducción de audio",
  "Failed to generate speech": "Error al generar voz",
  "Failed to generate audio. Please try again.": "Error al generar audio. Por favor, inténtalo de nuevo.",
  "Failed to play audio. Please try again.": "Error al reproducir audio. Por favor, inténtalo de nuevo.",
  
  // Update Notifications
  "update.updateAvailable": "Actualización disponible",
  "update.newVersionAvailable": "Nueva versión {{version}} disponible",
  "update.refreshToApply": "Actualiza para aplicar las últimas funciones y mejoras",
  "update.later": "Más tarde",
  "update.updateNow": "Actualizar ahora",
  
  // CSAT Feedback
  "We Value Your Feedback": "Valoramos tu opinión",
  "Give Feedback": "Dar opinión",
  "How would you rate your experience?": "¿Cómo calificarías tu experiencia?",
  "Very Dissatisfied": "Muy insatisfecho",
  "Dissatisfied": "Insatisfecho",
  "Neutral": "Neutral",
  "Satisfied": "Satisfecho",
  "Very Satisfied": "Muy satisfecho",
  "Select a rating": "Selecciona una calificación",
  "Comments or Bug Report": "Comentarios o informe de errores",
  "Please share your thoughts or report any issues...": "Por favor, comparte tus pensamientos o informa de cualquier problema...",
  "Contact Number": "Número de contacto",
  "Feedback Type": "Tipo de comentario",
  "Select a feedback type": "Selecciona un tipo de comentario",
  "Loading...": "Cargando...",
  "No feedback types available": "No hay tipos de comentarios disponibles", 
  "(Optional)": "(Opcional)",
  "Feedback Submitted": "Comentario enviado",
  "Thank you for your feedback!": "¡Gracias por tu comentario!",
  "Rating Required": "Calificación requerida",
  "Please select a rating before submitting.": "Por favor, selecciona una calificación antes de enviar.",
  "Submit Feedback": "Enviar comentario",
  "Submitting...": "Enviando...",
  "General": "General",
  "Bug": "Error",
  "Idea": "Idea",
  
  // Feedback Dashboard
  "Feedback Dashboard": "Panel de comentarios",
  "Total Feedbacks": "Total de comentarios",
  "All-time submissions": "Todas las presentaciones",
  "Average Rating": "Calificación promedio",
  "Out of 5 stars": "De 5 estrellas",
  "Feedback with Comments": "Comentarios con texto",
  "Detailed feedback": "Comentarios detallados",
  "Rating Distribution": "Distribución de calificaciones",
  "Breakdown of user satisfaction": "Desglose de satisfacción del usuario",
  "Rating Percentage": "Porcentaje de calificación",
  "Proportion of each rating": "Proporción de cada calificación",
  "Responses": "Respuestas",
  "All Feedback": "Todos los comentarios",
  "Detailed view of user submissions": "Vista detallada de las presentaciones de los usuarios",
  "ID": "ID",
  "Rating": "Calificación",
  "Comment": "Comentario",
  "Contact": "Contacto",
  "Date": "Fecha",
  "Page": "Página",
  "No feedback data available": "No hay datos de comentarios disponibles",
  "No comment": "Sin comentario",
  "Not provided": "No proporcionado",
  "Not available": "No disponible",
  
  // Authentication
  "Login": "Iniciar sesión",
  "Register": "Registrarse",
  "Username": "Nombre de usuario",
  "Password": "Contraseña",
  "Confirm Password": "Confirmar contraseña",
  "Email": "Correo electrónico",
  "Full Name": "Nombre completo",
  "Don't have an account?": "¿No tienes una cuenta?",
  "Already have an account?": "¿Ya tienes una cuenta?",
  "Login to continue": "Inicia sesión para continuar",
  "Create an account": "Crear una cuenta",
  "Passwords must match": "Las contraseñas deben coincidir",
  "Invalid email": "Correo electrónico inválido",
  "Required": "Requerido",
  "Unauthorized": "No autorizado",
  "You don't have permission to access this page.": "No tienes permiso para acceder a esta página."
};